import React from "react";
import { useRouteLoaderData } from "react-router";
import { CrumbProps } from "../../../../../Component/Breadcrumbs/Breadcrumb";
import { FieldsData } from "../../../../../API/fields";

export default function FieldCrumb({
  match,
}: CrumbProps<"fieldId">): React.ReactNode {
  const customer = useRouteLoaderData("customer") as FieldsData | undefined;

  if (!customer || !match.params.fieldId) {
    return null;
  }

  const feature = customer.fields.features.find(
    (feature) => feature.properties.id === Number(match.params.fieldId),
  );
  return feature && feature.properties.name;
}
